import { useEffect, useState } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import AsritasWordmark from "./AsritasWordmark";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: 0 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Nav() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.4 });
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <motion.div
        className="fixed top-0 left-0 right-0 h-[2px] bg-[#b88457] origin-left z-[90]"
        style={{ scaleX }}
      />
      <header
        data-testid="site-nav"
        className={`fixed top-0 left-0 right-0 z-[80] transition-colors duration-500 ${
          scrolled ? "bg-[#0f1724]/80 backdrop-blur-xl border-b border-white/5" : "bg-transparent"
        }`}
      >
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 h-[68px] flex items-center justify-between">
          <button
            data-testid="nav-logo"
            onClick={() => scrollTo("hero")}
            className="flex items-center group"
          >
            <AsritasWordmark height={26} />
          </button>

          <nav className="hidden md:flex items-center gap-9 font-mono-data text-[11px] tracking-[0.22em] text-zinc-400">
            {[
              ["01", "INCIDENT", "incident"],
              ["03", "WITNESS", "witness"],
              ["05", "HYPOTHESES", "hypotheses"],
              ["06", "ROOT CAUSE", "rootcause"],
            ].map(([n, label, id]) => (
              <button
                key={id}
                data-testid={`nav-${id}`}
                onClick={() => scrollTo(id)}
                className="hover:text-white transition-colors duration-300 flex items-center gap-2"
              >
                <span className="text-[#b88457]/60">{n}</span>
                {label}
              </button>
            ))}
          </nav>

          <button
            data-testid="nav-cta"
            onClick={() => scrollTo("rootcause")}
            className="font-mono-data text-[11px] tracking-[0.2em] text-[#0f1724] bg-[#b88457] px-5 py-2.5 hover:bg-[#e8e2d6] transition-colors duration-300"
          >
            BEGIN PLAYBACK
          </button>
        </div>
      </header>
    </>
  );
}
